{
  "userProfileNotificationsTitle": "Vos notifications",
  "userProfileNotificationsIsLoading": "Chargement de vos notifications...",
  "userProfileNotificationsIsEmpty": "Aucune notification!",
  "removeAny": "Supprimer",
  "displayTheAdDoc": "Afficher le document"
}
